import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  typePay: '',
  invoicesToPay: [],
  route: ''
};

export const invoicesSlices = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    setInvoicesToPay: (state, action) => {
      for (const key of Object.keys(action.payload)) {
        state[key] = action.payload[key];
      }
    }
  }
});

export const { setInvoicesToPay } = invoicesSlices.actions;
export default invoicesSlices.reducer;
